import Vue from 'vue'
import VueRouter from 'vue-router'
import iot from './iot'

Vue.use(VueRouter)

const routes = [
  ...iot
]

const router = new VueRouter({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to,from,savedPosition) {
  	// 路由刷新，页面回顶
	if(savedPosition){
		return savedPosition
	}else{
		return{
			x:0,
			y:0
		}
	}
  }
})

export default router
